import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';

import { AddressValidation } from '../../interfaces/address-validation';
import { AddressResponse } from '../../interfaces/address-response';
import { AddressInternationalResponse } from '../../interfaces/address-international-response';


@Component({
  selector: 'nsc-address-validation-dialog',
  templateUrl: './address-validation-dialog.component.html',
  styleUrls: ['./address-validation-dialog.component.scss']
})
export class AddressValidationDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<AddressValidationDialogComponent>) { }

  public addressValidationMessage: string;

  public missingSecondary: boolean;

  public secondaryNbr: string;

  public enteredAddress: AddressValidation;

  public correctedAddress: AddressResponse;

  public correctedInternationalAddress: AddressInternationalResponse;

  public addressCorrected: boolean;

  public continueOnlyWithValidAddress: boolean;

  public isAddressValid: boolean;

  public instructionalText: string;

  show = {
    suggestedAddress: true,
    enteredAddress: true
  };

  correctedAddressValues: any = {};

  ngOnInit() {
    this.correctedAddressValues = this.correctedAddress ? this.correctedAddress : this.correctedInternationalAddress;
    if (this.correctedAddress) {
      this.correctedAddressValues.delivery_line_1 = this.correctedAddress.delivery_line_1 ? this.correctedAddress.delivery_line_1 : '';
      this.correctedAddressValues.delivery_line_2 = this.correctedAddress.delivery_line_2;
    } else if (this.correctedInternationalAddress) {
      this.correctedAddressValues.address1 = this.correctedInternationalAddress.address1 ? this.correctedInternationalAddress.address1 : '';
    }
  }

  selectAddress(chosenAddress: any) {
    this.dialogRef.close(chosenAddress);
  }

  isNullorBlank(text: string): boolean {
    if (typeof text !== 'undefined' && text !== ' ' && text) {
      return false;
    }
    return true;
  }

}
